// services/storageService.js
import { storage } from '../firebase';
import { ref, listAll, getBlob } from 'firebase/storage';

const THEME_FOLDER_MAP = {
  carmen: 'Carmen',
  'don-pasquale': 'Don Pasquale',
  naksitrallid: 'Naksitrallid',
  pelleas: 'Pelleas ja Melisandre',
  volufloot: 'Võluflööt'
};

const GENDER_FOLDER_MAP = { mees: 'Man', naine: 'Woman' };

export async function getRandomThemeImageBase64(themeKey, genderKey) {
  const themeFolder = THEME_FOLDER_MAP[themeKey];
  const genderFolder = GENDER_FOLDER_MAP[genderKey];
  if (!themeFolder || !genderFolder) throw new Error('Invalid theme/gender combination');

  const folderRef = ref(storage, `${themeFolder}/${genderFolder}`);
  const listResult = await listAll(folderRef);

  const imageFiles = listResult.items.filter((i) => {
    const n = i.name.toLowerCase();
    return n.endsWith('.jpg') || n.endsWith('.jpeg') || n.endsWith('.png');
  });
  if (!imageFiles.length) throw new Error(`No image files found in ${themeFolder}/${genderFolder}`);

  const selected = imageFiles[Math.floor(Math.random() * imageFiles.length)];

  // ✅ Robust path: getBlob → FileReader → base64 (no data URL prefix)
  const blob = await getBlob(selected);
  if (!blob || !blob.size) throw new Error('Downloaded blob is empty');

  const base64 = await blobToBase64(blob);
  if (!base64 || base64.length < 100) {
    throw new Error('Base64 conversion failed or produced empty output');
  }

  return base64;
}

export function blobToBase64(blob) {
  return new Promise((resolve, reject) => {
    const r = new FileReader();
    r.onloadend = () => {
      const result = String(r.result || '');
      // Expect "data:image/jpeg;base64,XXXX..."
      const idx = result.indexOf(',');
      resolve(idx >= 0 ? result.slice(idx + 1) : '');
    };
    r.onerror = reject;
    r.readAsDataURL(blob);
  });
}
